<template>
  <div class="upload">
    <div class="preview-list">
      <ul class="preview-list-wrapper" v-show="previewList.length">
        <li v-for="(item, index) in previewList" :key="index">
          <div  class="preview-img">
            <img :src="item">
            <a href="javascript:;" class="close-icon" @click="delPreviewImg(index)"></a>
          </div>
        </li>
      </ul>
      <div class="default-preview" v-show="previewList.length < max">
        <label class="default-preview-wrapper">
          <img src="../assets/img/default.svg">
          <!-- capture="camera" -->
          <input type="file" accept="image/*" class="file" :multiple="multiple" @change="change">
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'upload',
  data () {
    return {
      previewList: [],
      uploadList: []
    }
  },
  props: {
    max: {
      type: Number,
      default: 5
    },
    multiple: {
      type: Boolean,
      default: false
    },
    quality: {
      type: Number,
      default: 0.6
    }
  },
  methods: {
    async change (e) {
      const files = Array.prototype.slice.call(e.target.files)
      // this.uploadList = files
      const filesLen = files.length
      if (this.previewList.length + filesLen <= 5 && filesLen) {
        this.$toast.loading({
          duration: 1000,
          message: '正在上传,请稍后...'
        })
        this.preview(files)
      } else {
        this.$toast(`最多只能上传${this.max}张图片`)
      }
    },
    async preview (files) {
      files.forEach((file, i) => {
        const size = file.size / 1024
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          this.previewList.push(reader.result)
        }
        reader.onloadend = () => {
          // this.uploadList.push(reader.result)
          if (size > 1024) {
            this.canvasDataURL(reader.result, { quality: this.quality }, base64 => {
              this.uploadList.push(this.convertBase64UrlToBlob(base64))
            })
          } else {
            // this.previewList.push(reader.result)
            this.uploadList.push(this.convertBase64UrlToBlob(reader.result))
          }
          if (i === files.length - 1) {
            // this.$toast.clear()
            this.$emit('change', this.uploadList)
          }
        }
      })
    },
    canvasDataURL (path, obj, callback) {
      const img = new Image()
      img.src = path
      img.onload = (e) => {
        // 默认按比例压缩
        let w = img.width
        let h = img.height
        const scale = w / h
        w = obj.width || w
        h = obj.height || (w / scale)
        let quality = 0.7 // 默认图片质量为0.7
        // 生成canvas
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        // 创建属性节点
        const anw = document.createAttribute('width')
        anw.nodeValue = w
        const anh = document.createAttribute('height')
        anh.nodeValue = h
        canvas.setAttributeNode(anw)
        canvas.setAttributeNode(anh)
        ctx.drawImage(img, 0, 0, w, h)
        // 图像质量
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
          quality = obj.quality
        }
        // quality值越小，所绘制出的图像越模糊
        const base64 = canvas.toDataURL('image/jpeg', quality)
        // 回调函数返回base64的值
        callback(base64)
      }
    },
    convertBase64UrlToBlob (urlData) {
      const arr = urlData.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    delPreviewImg (e) {
      this.previewList.splice(e, 1)
      this.uploadList.splice(e, 1)
      this.$emit('change', this.uploadList)
    }
  }
}
</script>

<style lang="less" scoped>
.upload {
  .preview-list {
    display: flex;
    flex-wrap: wrap;
  }
  .preview-list-wrapper {
    display: flex;
    li {
       margin-right: 0.4rem;
      .preview-img {
        position: relative;
        width: 1rem;
        height: 1rem;
        border: 0.5px solid #9e9e9e;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .close-icon {
          position: absolute;
          top: -0.2rem;
          right: -0.2rem;
          width: 0.4rem;
          height: 0.44rem;
          background: url('../assets/img/upload-close.png') center no-repeat;
          background-size: 100%;
        }
      }
    }
  }
  .default-preview {
    .default-preview-wrapper {
      width: 1rem;
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0.5px solid #9e9e9e;
      box-sizing: border-box;
      img {
        width: 0.41rem;
        height: 0.41rem;
      }
      input.file {
        width: 100%;
        height: 100%;
        display: none;
      }
    }
  }
}
</style>
